/**
 * Typescript version of the UtpTraceSummary controller
 * Use with UtpTraceSummaryEx template
 * Calls the Typescript version of the TraceDetails controller => `trace-details`
  */
angular.module('app').controller('UtpTraceSummaryExController', function (
// AngularJs services
$window, $q, $browser, $scope, $route, $routeParams, $location, $timeout, $http, ApiErrorService, 
// Third party services
toastr, moment, $localStorage, $uibModal, ngProgressFactory, 
// Api services
UserDetailsApi, // get the user from the cache if poss
UtpSummaryServiceApi, 
// App services
StateService, SettingsExService, TraceHubExService, 
// DownloadXmlExService: IDownloadXmlExService,
NewTracesExService, UserServiceApi, // get the user from the database/cache
DataValidatorServiceApi, TraceClassService, 
// TODO: Use this to store the search criteria
SearchParamsService, TraceDetailsServiceApi, locationHistoryService, ViewMediaModalService, ModalService) {
    // Expose the controller scope to the window for easy debugging
    let vm = this;
    $window.vm = vm;
    vm.data = {};
    // TODO: Create a default TraceSummaryRequest to use for our first search
    // let state: IUtpTraceSummaryState =
    vm.state = {
        isNewTraces: false,
        isSelected: false,
        autoRefresh: false,
        overTheShoulder: false,
        traceSummaryRequest: {
            UserId: -1,
            SimId: -1,
            TestSuiteId: -1,
            TestId: -1
        },
        allowSearch: false,
        searchInProgress: false,
        searchCancelled: false,
        searchTimeout: false,
        showSpinner: false,
        currentPage: 0,
        fromPage: 0,
        selectedTraceId: 0,
        searchCriteriaDisplay: {},
        appSettings: null,
        pageHttpCanceler: null
    };
    // vm.state = state;
    vm.traceProgress = ngProgressFactory.createInstance();
    vm.retryTraces = retryTraces;
    vm.pageChanged = pageChanged;
    vm.reload = reload;
    vm.changePageSize = changePageSize;
    // vm.downloadXml = downloadXml;
    // vm.downloadZip = downloadZip;
    vm.toggleAutoRefresh = toggleAutoRefresh;
    vm.historyBack = historyBack;
    vm.goBack = goBack;
    vm.rightClick = rightClick;
    vm.openSearch = openSearch;
    vm.cancelSearch = cancelSearch;
    vm.traceClass = traceClass;
    vm.subTraceClass = subTraceClass;
    // See vm.options for treeview methods
    // Required when used as a component controller
    this.$onInit = function () {
        init();
    };
    // Initialise
    function init() {
        vm.context.subTraceClass = vm.subTraceClass;
        // This is our initial state
        vm.state = {
            DateFormats: {},
            debug: false,
            itemsPerPage: 25,
            // This will be set to whichever page we are on so that we can navigate to next/prevPage
            fromPage: null,
            currentPage: 0,
            autoRefresh: true,
            isLastPage: true,
            // Disable search when we first load and reenable in user last page
            allowSearch: false,
            // Get stored our tester/sim/suite/test from localstorage
            selectedTester: StateService.selectedTester,
            selectedSim: StateService.selectedSim,
            selectedSuite: StateService.selectedSuite,
            selectedTest: StateService.selectedTest,
            isSearchResults: false,
            // TODO: Test to see if the asterisk appears
            isNewTraces: false,
            traceSummaryRequest: {
                Take: 25,
                UserId: StateService.selectedTester.Id,
                SimId: StateService.selectedSim.Id,
                TestSuiteId: StateService.selectedSuite.Id
            },
            // TODO: Deprecate Object Holding the data for displaying search Criteria Panel
            searchCriteriaDisplay: {
                searchTester: StateService.selectedTester.Name,
                searchSim: StateService.selectedSim.Name,
                searchSuite: 'All test cases',
                searchTest: 'All test cases'
            }
        };
        // Is this a DataValidator route
        let isDvSummary = $location.absUrl().indexOf('DataValidator') !== -1;
        vm.isDvSummary = isDvSummary;
        // Is this a Report route
        const isReport = $location.absUrl().indexOf('TraceSummarySource') !== -1;
        // Is this a regular trace summary route
        const isTraceSummary = !isDvSummary && !isReport;
        // If we have a TestSuiteId then use it for the search criteria display
        if (vm.state.traceSummaryRequest.TestSuiteId !== -1) {
            vm.state.searchCriteriaDisplay.searchSuite =
                vm.state.selectedSuite.Name;
        }
        // To Display the Search Criteria Panel we have to have non empty searchText so set it to something (it currently wont be displayed)
        if (vm.state.traceSummaryRequest.UserId !== -1) {
            vm.state.searchCriteriaDisplay.searchText =
                'Valid Search Data Acquired';
        }
        // Default ots to false
        vm.state.overTheShoulder = false;
        // Make sure we dont leave the data in the state service as it may impact on other pages
        StateService.reset();
        SettingsExService.getSettings().then(function (response) {
            vm.state.appSettings = response.data;
            // SIGNALR block
            const hub = TraceHubExService;
            hub.connectWithSpecificTransport('UtpTraceSummaryExController', vm.state.appSettings.SignalRTransport);
            // Stop SignalR when controller is destroyed. Ref: http://stackoverflow.com/questions/17813094/signalr-connection-freeze-other-ajax-requests
            $scope.$on('$destroy', function () {
                hub.stop('UtpTraceSummaryExController');
            });
            // Set the connectionId on vm.state.connectionId
            hub.on('UtpTraceSummaryExController', 'onInit', function (connId) {
                vm.state.connectionId = connId;
            });
            // The SignalR server raises the onNewTraces event
            // TODO: We could tidy this up a bit and do more in the Service
            hub.on('UtpTraceSummaryExController', 'onNewTraces', function (dto) {
                // Only accept traces for our own connection ID
                if (dto.ConnectionId !== vm.state.connectionId) {
                    return;
                }
                if (vm.dvFile) {
                    // in case of a dv file view, limit the refresh to the simulator and user associated to the dv file
                    vm.state.traceSummaryRequest.SimId = vm.dvFile.SimulatorId;
                    vm.state.traceSummaryRequest.UserId = vm.dvFile.UserId;
                }
                let nodes = dto.TreeViewNodes;
                // We want the items filtered for the user and search criteria
                let filteredNodes = NewTracesExService.filterRows(nodes, vm.state.traceSummaryRequest);
                if (filteredNodes.length === 0) {
                    return;
                }
                // TODO : Check on whether we are over the shoulder here?
                // And we may need to adjust the timestamps
                let timeAdjustedNodes = NewTracesExService.adjustToLocalTime(filteredNodes, vm.userDetails.TimezoneOffset);
                let lastPage = vm.data.LastPage;
                let autoRefresh = vm.state.autoRefresh;
                vm.isNewTraces = NewTracesExService.isNewTraces;
                // If we are auto refreshing and on the last page then render the nodes
                if (autoRefresh && lastPage) {
                    renderNewTraces(timeAdjustedNodes);
                    vm.state.isNewTraces = false;
                    return;
                }
                // If we are on the last page but not in autorefresh then cache the nodes
                if (lastPage) {
                    NewTracesExService.addToCache(timeAdjustedNodes);
                    vm.state.isNewTraces = NewTracesExService.isNewTraces;
                    return;
                }
            });
            // END SIGNALR block
            // TODO: We do not need this exposed to the vm as it is not used there
            // It is only used in a method to format dates
            // Only DateFormat is used
            vm.state.DateFormats = {
                DateTimeFormat: response.data.DateTimeFormat,
                DateFormat: response.data.DateFormat,
                TimeFormat: response.data.TimeFormat
            };
            UserDetailsApi.get().then(function (response) {
                // Find out who is logged in
                let connectedUser = response.data;
                vm.userDetails = connectedUser; // setup our user details
                // Are we a support user looking over the shoulder of a tester
                if (connectedUser.IsSupport || connectedUser.IsProjectTester) {
                    let testerId = $routeParams.testerId
                        ? $routeParams.testerId // over the shoulder of tester
                        : -1; // Support user
                    // Find out if we are over the shoulder of a tester
                    if (testerId > 0) {
                        vm.state.overTheShoulder = true;
                        vm.state.traceSummaryRequest.OverTheShoulder = true;
                        vm.state.traceSummaryRequest.UserId = testerId;
                    }
                }
                // Data Validator role: View trace summary for a single TraceUid
                // Route: #/TraceSummary/Uid/:traceUid
                let traceUid = $routeParams.traceUid;
                if (!angular.isUndefined(traceUid)) {
                    // TODO: Get file and show name instead of TraceUid
                    // vm.traceUid = traceUid;
                    DataValidatorServiceApi.dvFileByTraceUid(traceUid).then(function (response) {
                        let dvFile = response.data;
                        vm.dvFile = dvFile;
                    });
                    let traceSummaryRequest = {
                        TraceUid: traceUid
                    };
                    vm.state.traceSummaryRequest = traceSummaryRequest;
                    userLastPage();
                    if (connectedUser.IsSupport) {
                        let testerId = $routeParams.testerId;
                        UserServiceApi.getUser(testerId).then(function (response) {
                            let tester = response.data;
                            vm.tester = tester;
                        });
                    }
                    return;
                }
                userLastPage();
                if (connectedUser.IsTester &&
                    vm.state.traceSummaryRequest.UserId === -1) {
                    vm.state.supportedTester = {
                        Name: connectedUser.Description
                    };
                    resetSearchCriteria();
                }
            }, function () {
                // if no user details the redirect to login page
                toastr.error('Please make sure that you are logged in to OTS UTP!');
                $window.location.href = $browser.baseHref() + 'account/login';
                return;
            });
        });
    }
    // Render the treeview nodes
    function renderRows(data) {
        // If no rows to show then return
        if (data.Rows.length === 0) {
            return;
        }
        // If we are not autorefreshing then replace all and cache the rows
        if (!vm.state.autoRefresh) {
            vm.data.Rows = data.Rows;
            return;
        }
    }
    function isTraceTreeViewModel(arg) {
        return arg && arg.VerdictResult && typeof (arg.VerdictResult) === 'string';
    }
    function traceClass(item) {
        return TraceClassService.traceClass(item);
    }
    function subTraceClass(item) {
        return TraceClassService.subTraceClass(item);
    }
    // TODO: Simplify this as we are now using <summary-selected-trace> to show this
    function resetTraceDetails() {
        vm.state.selectedTester = { Id: -1, Name: 'Not selected' };
        vm.state.selectedSim = { Id: -1, Name: 'Not selected' };
        vm.state.selectedSuite = { Id: -1, Name: 'Not selected' };
        vm.state.selectedTest = { Id: -1, Name: 'Not selected' };
        vm.state.supportedTester = getItemById(vm.data.TesterLookups.Testers, vm.state.traceSummaryRequest.UserId);
    }
    function setTimestampText() {
        // If DataValidator then we do not need timestamp message
        let isDataValidatorSearch = $location.absUrl().indexOf('DataValidator') !== -1;
        if (isDataValidatorSearch) {
            vm.timestampText = '';
            return;
        }
        // Set the text for the timezone
        let yourLocalTime = [
            'Trace timestamps have been adjusted to your local time (',
            vm.data.Timezone,
            ')'
        ].join('');
        let testersLocalTime = [
            'Trace timestamps have been adjusted to the testers local time (',
            vm.data.Timezone,
            ')'
        ].join('');
        let isTester = vm.userDetails.IsTester;
        // If the user is not a Tester then they must be support (Team or standard)
        let overTheShoulder = !isTester && vm.state.traceSummaryRequest.UserId > 0;
        // If User is here on their own trace summary view timestamp for them, if they are supporting then timestamp for the supported user
        if (isTester || !overTheShoulder) {
            vm.timestampText = yourLocalTime;
        }
        else {
            vm.timestampText = testersLocalTime;
        }
    }
    // Page Functions
    // Used in all Page Functions
    let loadingMs = 10;
    function showSearchTimeoutModalWindow() {
        let modalOptions = {
            backdrop: 'static',
            okOnly: true,
            actionButtonText: 'Close',
            headerText: 'Search For Traces',
            bodyText: 'The trace search has timed out.<br/>Please refine your search criteria and try again.',
            headerExtraTag: '<i class="fa fa-exclamation-circle fa-red"/>' //  <i class="glyphicon glyphicon-info-sign" style="color:red"/>
        };
        ModalService.showModal({}, modalOptions);
    }
    function userLastPage() {
        vm.traceProgress.start();
        let promise;
        vm.data.Rows = [];
        promise = $timeout(function () {
            vm.state.showSpinner = true;
        }, loadingMs);
        // TODO: Figure out why we are coming here twice
        let traceSummaryRequest = vm.state.traceSummaryRequest;
        lastPage(traceSummaryRequest, false).then(function (response) {
            vm.state.searchInProgress = false;
            if (!response) {
                vm.traceProgress.complete();
                toastr.error('Invalid response.');
                vm.state.showSpinner = false;
                return;
            }
            if (response.status === -1) {
                vm.traceProgress.complete();
                if (vm.state.searchTimeout) {
                    showSearchTimeoutModalWindow();
                }
                vm.state.showSpinner = false;
                return;
            }
            let summaryDto = response.data;
            vm.data = summaryDto;
            vm.state.traceSummaryRequest = response.data.TraceSummaryRequest;
            vm.state.allowSearch = true;
            if (!vm.state.autoRefersh) {
                $timeout.cancel(promise);
                setTimestampText();
            }
            vm.state.showSpinner = false;
            // We use the fromPage to determine the paging direction
            vm.state.currentPage = response.data.LastPage;
            vm.state.fromPage = response.data.LastPage;
            // TODO: Unwrap this before passing to renderRows
            let traceTreeViewModels = response.data.Rows;
            renderRows(summaryDto);
            resetTraceDetails();
            vm.traceProgress.complete();
        });
    }
    function userFirstPage(callFromPaginator = false) {
        // Empty rows unless we are in autorefresh
        vm.state.autoRefresh = false;
        vm.data.Rows = [];
        let promise = $timeout(function () {
            vm.state.showSpinner = true;
        }, loadingMs);
        let traceSummaryRequest = vm.state.traceSummaryRequest;
        firstPage(traceSummaryRequest, false, callFromPaginator).then(function (response) {
            if (!response) {
                vm.traceProgress.complete();
                toastr.error('Invalid response.');
                vm.state.showSpinner = false;
                return;
            }
            if (response.status === -1) {
                vm.traceProgress.complete();
                if (vm.state.searchTimeout) {
                    showSearchTimeoutModalWindow();
                }
                vm.state.showSpinner = false;
                return;
            }
            let summaryDto = response.data;
            vm.data = summaryDto;
            vm.state.traceSummaryRequest = summaryDto.TraceSummaryRequest;
            if (!vm.state.autoRefresh) {
                $timeout.cancel(promise);
                vm.state.showSpinner = false;
            }
            // We use the fromPage to determine the paging direction
            vm.state.currentPage = 1;
            vm.state.fromPage = vm.state.currentPage;
            renderRows(summaryDto);
            resetTraceDetails();
        });
    }
    function userPrevPage() {
        // Empty rows unless we are in autorefresh
        vm.state.autoRefresh = false;
        vm.data.Rows = [];
        let promise = $timeout(function () {
            vm.state.showSpinner = true;
        }, loadingMs);
        let traceSummaryRequest = vm.state.traceSummaryRequest;
        prevPage(traceSummaryRequest, false).then(function (response) {
            if (!response) {
                vm.traceProgress.complete();
                toastr.error('Invalid response.');
                vm.state.showSpinner = false;
                return;
            }
            if (response.status === -1) {
                vm.traceProgress.complete();
                if (vm.state.searchTimeout) {
                    showSearchTimeoutModalWindow();
                }
                vm.state.showSpinner = false;
                return;
            }
            let summaryDto = response.data;
            vm.data = summaryDto;
            vm.state.traceSummaryRequest = summaryDto.TraceSummaryRequest;
            if (!vm.state.autoRefresh) {
                $timeout.cancel(promise);
                vm.state.showSpinner = false;
            }
            // We use the fromPage to determine the paging direction
            vm.state.fromPage = vm.state.currentPage;
            renderRows(summaryDto);
            resetTraceDetails();
        });
    }
    function userNextPage() {
        // Empty rows unless we are in autorefresh
        vm.state.autoRefresh = false;
        vm.data.Rows = [];
        let promise = $timeout(function () {
            vm.state.showSpinner = true;
        }, loadingMs);
        let traceSummaryRequest = vm.state.traceSummaryRequest;
        nextPage(traceSummaryRequest, false).then(function (response) {
            if (!response) {
                vm.traceProgress.complete();
                toastr.error('Invalid response.');
                vm.state.showSpinner = false;
                return;
            }
            if (response.status === -1) {
                vm.traceProgress.complete();
                if (vm.state.searchTimeout) {
                    showSearchTimeoutModalWindow();
                }
                vm.state.showSpinner = false;
                return;
            }
            let summaryDto = response.data;
            vm.data = summaryDto;
            vm.state.traceSummaryRequest = summaryDto.TraceSummaryRequest;
            if (!vm.state.autoRefresh) {
                $timeout.cancel(promise);
                vm.state.showSpinner = false;
            }
            // We use the fromPage to determine the paging direction
            vm.state.fromPage = vm.state.currentPage;
            renderRows(summaryDto);
            resetTraceDetails();
        });
    }
    // END Page Functions
    function retryTraces() {
        // TODO: Figure out why pageChanged does not work as expected here
        if (vm.state.currentState === vm.state.LastPage) {
            userLastPage();
            vm.state.autoRefresh = true;
            return;
        }
        if (vm.state.currentPage === 1) {
            userFirstPage();
            return;
        }
        if (vm.state.currentPage < vm.state.fromPage) {
            userPrevPage();
            return;
        }
        if (vm.state.currentPage > vm.state.fromPage) {
            userNextPage();
            return;
        }
    }
    // TODO: refactor this to take parameters from the pager
    function pageChanged() {
        let fromPage = vm.state.fromPage;
        let toPage = vm.state.currentPage;
        let lastPage = vm.data.LastPage;
        if (toPage === lastPage) {
            userLastPage();
            vm.state.autoRefresh = true;
            return;
        }
        if (toPage === 1) {
            // Get First Page
            userFirstPage(true);
            return;
        }
        if (toPage < fromPage) {
            // Get prev page
            userPrevPage();
            return;
        }
        if (toPage > fromPage) {
            // Get Next page
            userNextPage();
            return;
        }
    }
    function getItemById(collection, id) {
        // TODO: If we can't find the item we should return the
        return _.find(collection, { Id: id });
    }
    function clearSelectedState() {
        vm.summarySelectedTraceParams = null;
        resetTraceDetails();
    }
    // node is a ya-treeview node object
    function setState(node) {
        let tvNode = node.$model;
        // If we are we don't have a traceId then we are not on the root node
        if (!tvNode.traceId) {
            return;
        }
        // TODO: We pass the traceSummaryRequest to the download-xml component
        // We need this to get the traceXmlContent
        vm.state.selectedTraceId = tvNode.traceId;
        vm.state.selectedTrace = tvNode;
        let userId = tvNode.UserId;
        let simId = tvNode.SimId;
        let suiteId = tvNode.SuiteId;
        let testId = tvNode.TestId;
        let lookups = vm.data.TesterLookups;
        vm.state.isSelected = true;
        // TODO: Why are we doing this??
        // Lookup tester/sim/suite
        if (userId <= 0) {
            vm.state.selectedTester = { Id: userId, Name: 'Unknown' };
        }
        else {
            // If we don't have a lookup for this tester then make him unknown
            vm.state.selectedTester = getItemById(lookups.Testers, userId) || {
                Id: 0,
                Name: 'Unknown'
            };
            // Always use the Id from the trace even if we don't have a lookup for it
            vm.state.selectedTester.Id = userId;
        }
        // Handle case where we have a simId/suiteId but it has been deleted from the Sims table
        vm.state.selectedSim = getItemById(lookups.Sims, simId) || {
            Id: simId,
            Name: 'Unknown'
        };
        vm.state.selectedSuite = getItemById(lookups.Suites, suiteId) || {
            Id: suiteId,
            Name: 'Unknown'
        };
        // Make api call for test name and xml attribute items
        UtpSummaryServiceApi.getTestIdNameResponse(testId).then(function (response) {
            let test = response.data;
            vm.state.selectedTest = test;
            // Always use the testId from the trace
            vm.state.selectedTest.Id = testId;
        });
        let traceId = tvNode.traceId;
        UtpSummaryServiceApi.getTraceXmlAttributes(traceId).then(function (response) {
            vm.data.traceAttributes = response.data;
        });
        // First steps to setting up summary-selected-trace
        let summarySelectedTraceParams = {
            traceId: traceId,
            mode: { view: false, run: false },
            user: vm.userDetails,
            overTheShoulder: vm.state.overTheShoulder
        };
        vm.summarySelectedTraceParams = summarySelectedTraceParams;
    }
    // TODO: Create a new controller/service solely for the treeview
    vm.context = {
        selectedNodes: [],
        subTraceClass: Function
    };
    // See TraceDetailsController
    // Treeview utility to populate treeview children of children
    function nodifyChildren(node, context) {
        // TODO: Why are we using timeout with out a delay arg?
        $timeout(function () {
            angular.forEach(node.$children, function (node) {
                if (node.$hasChildren) {
                    let options = {};
                    let children = node.$model.children;
                    node.$children = context.nodifyArray(children, node, options);
                }
            });
        });
    }
    // Tree view functionality
    // These options must be defined directly on the scope
    vm.options = {
        onExpand: function ($event, node, context) {
            // onExpand => lazyLoad Message.Fields
            // TODO: Do we need to toggle autorefresh here?
            context.selectedNodes = [node];
            context.subTraceClass = vm.subTraceClass;
            // Handle node.$model.MessageType differently
            if (node.$model.MessageType === 'raw-message') {
                showRawMessage(node.$model.traceId, node, context);
                // Update selected trace details
                setState(node);
                return;
            }
            else if (node.$model.MessageType !== 'CryptoSubItem') {
                renderNodeChildren(node, context);
            }
        },
        onSelect: function ($event, node, context) {
            context.selectedNodes = [node];
            context.subTraceClass = vm.subTraceClass;
            // Disable toggle on select OTSUTP-206
            vm.toggleAutoRefresh(false);
            setState(node);
        },
        onCollapse: function ($event, node, context) {
            context.selectedNodes = [node];
            context.subTraceClass = vm.subTraceClass;
            setState(node);
        }
    };
    function renderNodeChildren(node, context, metadata = []) {
        // Otherwise get the node children
        let loaded = node.$model.loaded;
        setState(node);
        if (node.$model.traceId > 0 && !loaded) {
            // Show progress bar in 100 ms
            let promise = $timeout(function () {
                vm.traceProgress.start();
            }, 1);
            // Disable toggle on select OTSUTP-206
            vm.toggleAutoRefresh(false);
            // NOTE: The DataValidator summary traces are wider
            let isDvSummary = $location.absUrl().indexOf('DataValidator') !== -1;
            if (isDvSummary) {
                UtpSummaryServiceApi.getDvTraceChildren(node.$model.traceId, true).then(function (response) {
                    // Cancel the promise of a progress bar
                    vm.traceProgress.complete();
                    $timeout.cancel(promise);
                    node.$model.children = response.data;
                    node.$children = context.nodifyArray(response.data);
                    nodifyChildren(node, context); // Do this to populate grandchildren
                    node.$model.loaded = true;
                });
                return;
            }
            // TODO: Get rid of repetition above and below
            UtpSummaryServiceApi.getTraceChildren(node.$model.traceId).then(function (response) {
                // Cancel the promise of a progress bar
                vm.traceProgress.complete();
                $timeout.cancel(promise);
                // check if we need to add the metadata to the structure to render
                const childrenNodes = [];
                if (metadata.length > 0) {
                    const metadataRoot = {
                        children: [],
                        fullLabel: 'Metadata',
                        label: 'Metadata',
                        loaded: true,
                        MessageType: '',
                        nodeType: '',
                        ProjectIterationId: node.$model.ProjectIterationId,
                        SimId: node.$model.SimId,
                        skipSubTraceClassCalculation: true,
                        SuiteId: node.$model.SuiteId,
                        TestId: node.$model.TestId,
                        Timestamp: node.$model.Timestamp,
                        traceId: node.$model.traceId,
                        TraceUid: node.$model.TraceUid,
                        UserId: node.$model.UserId
                    };
                    metadata.forEach(element => {
                        metadataRoot.children.push({
                            fullLabel: `${element.Key} (${element.Value})`,
                            label: `${element.Key} (${element.Value})`,
                            children: null,
                            loaded: true
                        });
                    });
                    // add the metadata to the collection of node children
                    childrenNodes.push(metadataRoot);
                }
                response.data.forEach(element => {
                    childrenNodes.push(element);
                });
                node.$model.children = childrenNodes;
                node.$children = context.nodifyArray(childrenNodes);
                nodifyChildren(node, context); // Do this to populate grandchildren
                node.$model.loaded = true;
            });
        }
    }
    function showRawMessage(traceId, node, context) {
        TraceDetailsServiceApi.getRawMessage(traceId, true).then(function (response) {
            let media = response.data;
            try {
                // If the content is JSON then we'll defer to the server because it will format it all nicely for us
                let obj = JSON.parse(media.Content);
                if (obj && typeof obj === 'object') {
                    renderNodeChildren(node, context, media.Metadata);
                    return;
                }
            }
            catch (e) { }
            ViewMediaModalService.open(media);
            // Collapse node after delay
            this.timeout(() => {
                node.collapsed = true;
            }, 300);
        });
    }
    // TODO: Use the ViewMedia modal here
    function open(media) {
        let modalInstance = $uibModal.open({
            animation: true,
            backdrop: 'static',
            templateUrl: 'scripts/app/partials/ViewMedia/ViewMedia.tpl.html',
            controller: 'ViewMediaController',
            controllerAs: 'vm',
            windowClass: 'view-media', // see app-modals.css for settings
            size: 'lg',
            resolve: {
                media: function () {
                    return media;
                }
            }
        });
        modalInstance.result.then(function () {
            // ok
        }, function () {
            // cancel
        });
    }
    // Reload Page
    function reload() {
        vm.state.autoRefresh = true;
        resetSearchCriteria();
        userLastPage();
        vm.state.isSelected = false;
        vm.searchDto = null;
        clearSelectedState();
        // TODO: Determine if we want to reset the SearchParamsService also
        SearchParamsService.reset();
    }
    // END TreeView Logic
    function resetSearchCriteria() {
        // console.log(vm.state);
        // Delete the searchDTO as we have no searchCriteria after a reset.
        delete vm.state.searchDto;
        vm.state.searchInProgress = false;
        if (!vm.state.overTheShoulder) {
            // Clear the search Criteria Display Panel
            vm.state.searchCriteriaDisplay = {};
            vm.state.traceSummaryRequest = {
                UserId: -1,
                SimId: -1,
                TestSuiteId: -1,
                TestId: -1
            };
        }
        else {
            vm.state.traceSummaryRequest = {
                UserId: vm.state.traceSummaryRequest.UserId,
                SimId: -1,
                TestSuiteId: -1,
                TestId: -1,
                OverTheShoulder: true
            };
            vm.state.searchCriteriaDisplay = {
                searchTester: vm.state.supportedTester.Name,
                searchSim: 'All simulators',
                searchSuite: 'All test cases',
                searchTest: 'All test cases',
                searchText: 'Valid Search Data Acquired'
            };
        }
    }
    function changePageSize(itemsPerPage) {
        // TODO: Deprecate vm.state.itemsPerPage
        vm.state.itemsPerPage = itemsPerPage;
        vm.state.traceSummaryRequest.Take = itemsPerPage;
        userLastPage();
    }
    function toggleAutoRefresh(isAutoRefresh) {
        vm.state.autoRefresh = angular.isUndefined(isAutoRefresh)
            ? !vm.state.autoRefresh
            : isAutoRefresh;
        if (!vm.state.autoRefresh) {
            return;
        }
        else {
            if (vm.state.autoRefresh && vm.state.isSelected) {
                vm.state.isSelected = false;
                vm.state.selectedTrace = null;
            }
            clearSelectedState();
        }
        // Goto the last page
        vm.state.currentPage = vm.data.LastPage;
        vm.pageChanged();
        // Get the cached nodes
        let nodes = NewTracesExService.fetchFromCache();
        renderNewTraces(nodes);
    }
    // TODO: Use the back button and the StateService to restore state in tester-home
    // For data validator we use historyBack for DataValidator and Support
    function historyBack() {
        $window.history.back();
    }
    function goBack() {
        // History can be broken and insecure so better use your own service instead of $window.history.back()
        $window.location = locationHistoryService.get().replace('/TraceSummary', '');
    }
    // TODO: We could use a service to do most of the processing
    function renderNewTraces(nodes) {
        if (nodes.length === 0) {
            return;
        }
        // TODO: Figure out if we really need to do this
        // let nonDuplicateNewRows = NewTracesExService.removeDuplicateTvNodes(
        //     nodes,
        //     vm.data.Rows
        // );
        let nonDuplicateNewRows = nodes;
        // Adjust the total items for the pager
        vm.data.TotalItems += nonDuplicateNewRows.length;
        // Adjust trace summary request for paging first/next/prev
        vm.state.traceSummaryRequest.TotalPagedTraces = vm.data.TotalItems;
        // Add to the bottom and remove from the top to preserve the itemsPerPage
        let itemIds = _.map(vm.data.Rows, 'Id');
        // Reverse the order here before processing, so the latest one is added to the list last and appears on the top.
        angular.forEach(nonDuplicateNewRows.reverse(), function (item) {
            if (!_.includes(itemIds, item.Id) && item.Id !== 0) {
                // Add it to the beginning of the array - so it appears at the top
                vm.data.Rows.unshift(item);
                //  if we are over the page limit , remove the last element.
                if (vm.data.Rows.length > vm.state.itemsPerPage) {
                    vm.data.Rows.splice(vm.data.Rows.length - 1);
                }
            }
        });
        let newIds = _.map(vm.data.Rows, 'Id');
        // Now fix up our Prev Page minTraceId
        vm.state.traceSummaryRequest.MinTraceId = _.min(newIds);
        vm.state.isNewTraces = false;
    }
    function rightClick(event) {
        // console.log(event);
    }
    // Data Validator Search
    function openDvSearch() {
        // Get the known params testerId and traceUid
        let traceUid = $routeParams.traceUid;
        let testerId = vm.userDetails.IsSupport
            ? $routeParams.testerId
            : vm.userDetails.Id;
        let modalInstance = $uibModal.open({
            animation: true,
            component: 'dvSearchModal', // dv-search-modal.component.ts,
            resolve: {
                traceSummaryRequest: function () {
                    return vm.state.traceSummaryRequest;
                }
            }
        });
        modalInstance.result.then(function (traceSummaryRequest) {
            vm.traceSummaryRequest = traceSummaryRequest;
            // Set variables picked up in LastPage method
            vm.state.searchCriteriaDisplay.searchTester = testerId;
            vm.state.traceSummaryRequest.TraceUid = traceUid;
            vm.state.traceSummaryRequest.advancedQuery =
                traceSummaryRequest.advancedQuery;
            vm.state.traceSummaryRequest.advancedQueryContains =
                traceSummaryRequest.advancedQueryContains;
            vm.state.traceSummaryRequest.DVFileOnly =
                traceSummaryRequest.DVFileOnly;
            if (traceSummaryRequest.DVFailedTraces !== undefined &&
                traceSummaryRequest.DVFailedTraces === true) {
                vm.state.traceSummaryRequest.DVFailedTraces =
                    traceSummaryRequest.DVFailedTraces;
            }
            else {
                vm.state.traceSummaryRequest.DVFailedTraces = false;
            }
            // TODO: Construct a caption for the search criteria
            vm.searchCaption = getSearchCaption(traceSummaryRequest);
            // TODO: Show the spinner
            userLastPage();
        }, 
        // cancel callback
        function () {
            // console.log('modal-component dismissed at: ' + new Date());
        });
    }
    function getSearchCaption(tcr) {
        let caption = '';
        caption =
            angular.isDefined(tcr.advancedQuery) &&
                tcr.advancedQuery.trim().length > 0
                ? caption + tcr.advancedQuery
                : caption;
        caption =
            angular.isDefined(tcr.advancedQueryContains) &&
                tcr.advancedQueryContains
                ? caption + ' Expanded search.'
                : caption;
        caption =
            angular.isDefined(tcr.DVFailedTraces) && tcr.DVFailedTraces
                ? caption + ' Failed traces only.'
                : caption;
        caption = caption.length > 0 ? 'Search: ' + caption : caption;
        return caption;
    }
    // Search Modal
    function cancelSearch() {
        if (vm.state.pageHttpCanceler) {
            vm.state.pageHttpCanceler.resolve();
        }
        vm.state.searchCancelled = true;
        vm.data.TotalItems = 0;
        vm.state.searchInProgress = false;
    }
    function openSearch() {
        // Find out if we are going to do a DataValidator search
        let isDataValidatorSearch = $location.absUrl().indexOf('DataValidator') !== -1
            || $location.absUrl().indexOf('TraceSummaryDV') !== -1;
        if (isDataValidatorSearch) {
            openDvSearch();
            return;
        }
        let isTesterView = false;
        if ($routeParams.testerId) {
            isTesterView = true;
        }
        // TODO: Stash the stuff in the service
        let searchParams = {
            user: vm.userDetails,
            isTesterView: isTesterView,
            traceSummaryRequest: vm.state.traceSummaryRequest,
            searchState: vm.state.searchDto
                ? vm.state.searchDto.searchState
                : null,
            testerLookups: vm.data.TesterLookups,
            overTheShoulder: vm.state.overTheShoulder
        };
        SearchParamsService.putSearchParams(searchParams);
        // TODO: Now get them at the other end
        let modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'scripts/app/partials/UtpTraceSummary/Search/UtpTraceSummarySearch.tpl.html',
            controller: 'UtpTraceSummarySearchController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            // TODO: Use the SearchCriteriaService for this
            // Send these variables INTO the modal
            resolve: {
                user: function () {
                    return vm.userDetails;
                },
                isTesterView: function () {
                    return isTesterView;
                },
                traceSummaryRequest: function () {
                    return vm.state.traceSummaryRequest;
                },
                searchState: function () {
                    if (angular.isUndefined(vm.state.searchDto)) {
                        return null;
                    }
                    return vm.state.searchDto.searchState;
                },
                // TODO: Get these when we are in the search dialog
                testerLookups: function () {
                    return vm.data.TesterLookups;
                },
                overTheShoulder: function () {
                    return vm.state.overTheShoulder;
                }
            }
        });
        modalInstance.result.then(function (searchDto) {
            vm.searchDto = searchDto;
            vm.state.searchDto = searchDto;
            // TODO: Query the number of traces for the search and don't return with less than zero
            vm.state.traceSummaryRequest = searchDto.traceSummaryRequest;
            vm.state.searchInProgress = true;
            userLastPage();
            return;
        }, function () { });
    }
    function timeoutPageDisplay() {
        vm.data.TotalItems = 0;
        vm.state.searchTimeout = true;
        vm.state.pageHttpCanceler.resolve();
    }
    function navigateToPage(uri, req) {
        let validAppSettings = (vm.state.appSettings !== null) && (vm.state.appSettings !== undefined);
        const timeoutMilliseconds = validAppSettings ? vm.state.appSettings.TraceSummarySearchTimeoutSeconds * 1000 : 60000;
        vm.state.pageHttpCanceler = $q.defer();
        vm.state.searchCancelled = false;
        vm.state.searchTimeout = false;
        let timeoutPromise = $timeout(function () { timeoutPageDisplay(); }, timeoutMilliseconds);
        return $http.post(uri, req, { timeout: vm.state.pageHttpCanceler.promise })
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        }).finally(() => { $timeout.cancel(timeoutPromise); });
    }
    // Required to be separate from the controllers as we need to set a specific timeout for these commands.
    function lastPage(req, addChildren) {
        return navigateToPage(`api/UtpSummary/LastPage?addChildren=${addChildren}`, req);
    }
    function firstPage(req, addChildren, callFromPaginator = false) {
        return navigateToPage(`api/UtpSummary/FirstPage?addChildren=${addChildren}&shouldFillFirstPage=${!callFromPaginator}`, req);
    }
    function prevPage(req, addChildren) {
        return navigateToPage(`api/UtpSummary/PrevPage?addChildren=${addChildren}`, req);
    }
    function nextPage(req, addChildren) {
        return navigateToPage(`api/UtpSummary/NextPage?addChildren=${addChildren}`, req);
    }
});
